import React from 'react';

import { SmallImageItem } from '../components/script-editor/tools/components';

import ScreenLocationBackgroundIcon from '../assets/icons/screen-location-background.svg';
import ScreenLocationCenterIcon from '../assets/icons/screen-location-center.svg';
import ScreenLocationForegroundIcon from '../assets/icons/screen-location-foreground.svg';
import ScreenLocationLowerLeftIcon from '../assets/icons/screen-location-lowerleft.svg';
import ScreenLocationLowerRightIcon from '../assets/icons/screen-location-lowerright.svg';
import ScreenLocationUpperLeftIcon from '../assets/icons/screen-location-upperleft.svg';
import ScreenLocationUpperRightIcon from '../assets/icons/screen-location-upperright.svg';

export const ScreenLocations = [
  {
    value: 0,
    title: <SmallImageItem text="Foreground" imageUrl={ScreenLocationForegroundIcon} />,
  },
  {
    value: 1,
    title: <SmallImageItem text="Background" imageUrl={ScreenLocationBackgroundIcon} />,
  },
  {
    value: 2,
    title: <SmallImageItem text="Upper-left" imageUrl={ScreenLocationUpperLeftIcon} />,
  },
  {
    value: 3,
    title: <SmallImageItem text="Upper-right" imageUrl={ScreenLocationUpperRightIcon} />,
  },
  {
    value: 4,
    title: <SmallImageItem text="Lower-left" imageUrl={ScreenLocationLowerLeftIcon} />,
  },
  {
    value: 5,
    title: <SmallImageItem text="Lower-right" imageUrl={ScreenLocationLowerRightIcon} />,
  },
  {
    value: 6,
    title: <SmallImageItem text="Center" imageUrl={ScreenLocationCenterIcon} />,
  },
];

export const ImageEffects = [
  {
    value: 0,
    title: 'None',
  },
  {
    value: 1,
    title: 'Slow zoom in',
  },
  {
    value: 2,
    title: 'Slow zoom out',
  },
];

export const Presenters = [
  {
    value: 0,
    title: 'Self',
  },
  {
    value: 1,
    title: 'Interviewer',
  },
  {
    value: 2,
    title: 'Interviewee',
  },
  {
    value: 3,
    title: 'Organization',
  },
];

export const NameScript = [
  {
    value: 0,
    title: 'First name',
  },
  {
    value: 1,
    title: 'Full name',
  },
  {
    value: 2,
    title: 'Organization',
  },
];
